import { useMutation } from 'react-query';

import Api from '../api/api';

export type CreatePaymentResponse = {
  paymentIntent: string;
  ephemeralKey: string;
  customerId: string;
};

export const createPaymentSheet = async (eventId: string): Promise<CreatePaymentResponse> => {
  const [response, bodyOrError] = await Api.post(`users/create-payment-sheet`, {
    isCheckout: true,
    eventId,
  });

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useCreatePaymentSheet = () => {
  return useMutation({ mutationFn: createPaymentSheet });
};
